import { Component, DoCheck, EventEmitter, Inject, OnInit, Output, DOCUMENT } from '@angular/core';
import { NavbarService } from './navbar.service';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { FiltersService } from '../../services/filters.service';
import { NavigationMenu } from 'src/app/global/enums';
import { Router } from '@angular/router';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit, DoCheck {

  filters: ContractModel | undefined;
  isCollapsed = true; // Default collapsed state

  @Output() coverLeft: EventEmitter<string> = new EventEmitter();
  @Output() sidebarStateChange: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private _navbarService: NavbarService,
    private _filtersService: FiltersService,
    private _router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {}

  get NavigationMenu() {
    return NavigationMenu;
  }

  get canShowSidebarControls(): boolean {
    return this._navbarService.canShowSidebarControls();
  }

  ngOnInit() {
    this.tabHighlight();
    this._filtersService.selectedFiltersObservable.subscribe(f => {
      this.filters = f;
    });
  }

  ngDoCheck() {
    this.tabHighlight();

    // Reset to collapsed when on filter page
    if (!this.canShowSidebarControls && !this.isCollapsed) {
      this.isCollapsed = true;
      this.sidebarStateChange.emit(this.isCollapsed);
    }
  }

  tabHighlight() {
    const coverLeft = this.document.getElementById('cover-left');

    if (!coverLeft) {
      return; // Element doesn't exist in new UI, exit early
    }

    if (this.document.location.href.lastIndexOf('/filter') > -1) {
      // @ts-ignore
      // TODO: Should avoid referencing elements in the DOM not thru Angular.
      // this.document.getElementById('home').className = 'active-link';
      // @ts-ignore
      coverLeft.style.display = 'block';
    } else {
      // @ts-ignore
      coverLeft.style.display = 'none';
    }
  }

  //Get the current path without query parameters and check if it includes the keyword
  isRouteActiveGivenKeyword(keyword: string): boolean {
    const path = this._router.url.split('?')[0].toLowerCase();
    return path.includes(keyword.toLowerCase());
  }

  public canNavigateTo(menu: NavigationMenu): boolean {
    return this._navbarService.canNavigateTo(menu);
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;

    // Emit state change for other components that need to adjust layout
    this.sidebarStateChange.emit(this.isCollapsed);
  }
}
